/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Save_TitleInputs */



/**
* | output |
* | --- |
* | "Save Standards Preset" |
*
* @param {Standards_Preset_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_save_title = /** @type {((inputs?: Standards_Preset_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Save Standards Preset")
	if (locale === "de") return /** @type {LocalizedString} */ ("Save Standards Preset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Save Standards Preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Save Standards Preset")
	if (locale === "es") return /** @type {LocalizedString} */ ("Save Standards Preset")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Save Standards Preset")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Save Standards Preset")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Save Standards Preset")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Save Standards Preset")
	return /** @type {LocalizedString} */ ("Save Standards Preset")
});